// extracted by mini-css-extract-plugin
export default {"container":"InformationDropdown_container__QbakB","title":"InformationDropdown_title__4ndsw","content":"InformationDropdown_content__3-dYZ"};